import { APIService } from '@services/api/common-services';
import { APICONFIG } from '@config/api.config';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { ICAidDataType, ICAidQuery } from '@components/contractor360KAE/components/aidModal';

export interface ICAidResponse {
	mutate: UseMutateFunction<ICAidDataType, Error, ICAidQuery, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useCAidMutation = (): ICAidResponse => {
	const cAidDataFn = async ({ userId, ...requestData }: ICAidQuery): Promise<ICAidDataType> => {
		return APIService.putData<ICAidDataType>(`${APICONFIG.C_AID}${userId}/`, requestData);
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: cAidDataFn,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
